import React, { Component } from 'react';


class DoorMobile extends Component {
  render() {
    return (
      <div className="">
        <div className="row">
          <div className="col-12 mt-3">
            <div className="card">
              <div className="card-header text-muted font-weight-bold text-uppercase ">
                ดาวน์โหลด STARVEGAS
              </div>
              <ui className="list-group list-group-flush color-hover">
                <li className="list-group-item text-muted" type="text">
                  <button
                    className="btn btn-gclub col-12 text-white"
                    onClick={() =>
                      window.open('https://dl3.svgame168.com/StarVegasMobile/download_new_apk.ashx', '_blank')
                    }
                  >
                    สำหรับ Android
                  </button>
                </li>
                <li className="list-group-item text-muted" type="text">
                  <button
                    className="btn btn-gclub col-12 text-white"
                    onClick={() =>
                      window.open('https://dl3.svgame168.com/StarVegasMobile_IPA/download_new_ipa.ashx', '_blank')
                    }
                  >
                     สำหรับ IOS  
                  </button>
                </li>
              </ui>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



export default DoorMobile;
